import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-recaptch',
  templateUrl: './recaptch.component.html',
  styleUrls: ['./recaptch.component.scss']
})
export class RecaptchComponent implements OnInit {
  @Output() onSuccess: EventEmitter<string> = new EventEmitter();
  @Input() actionName: string = 'FORM_SUBMIT';

  constructor(
    private recaptchaV3Service: ReCaptchaV3Service
  ) { }

  ngOnInit() { }

  executeRecaptcha() {
    this.recaptchaV3Service.execute(this.actionName).subscribe((token: string) => {
      this.onSuccess.emit(token);
    }, error => {
      // console.error('reCAPTCHA execution error:', error);
    });
  }

}